module.exports = __webpack_public_path__ + "static/media/item-tick.b6259229.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/school_money/item-tick.svg
// module id = 721
// module chunks = 0